import { ArticleItem } from 'types'

export const quarantineGamesTextEs: Array<ArticleItem> = [
  {
    text: '',
    style: ['space'],
  },
  {
    text: 'Autoría: Marta Macedo Brietzke',
    style: ['paragraph', 'margin'],
  },
  {
    text: '',
    style: ['space'],
  },
  {
    text:
      'Los juegos que se describen a continuación fueron diseñados en 2020, basándose en los juegos utilizados en mi trabajo de maestría. En el momento en que fueron pensados, el mundo estaba experimentando las dos primeras olas de la pandemia de Covid-19, una época en la que el contacto y la presencia física se hicieron difíciles debido a las condiciones sanitarias y epidemiológicas. La intención de estas actividades es mantener algunos de los aspectos posibles de la enseñanza colectiva de instrumentos musicales, incluso a distancia, con la ayuda de las tecnologías digitales. Para su aplicación, sugiero que cada profesor cree con sus estudiantes un entorno virtual de intercambio, como, por ejemplo, un grupo de mensajería, en el que los estudiantes compartan sus creaciones, experiencias y descubrimientos. Espero que el mundo no tenga que experimentar nuevas fases de aislamiento y que estas actividades puedan utilizarse en otros momentos de enseñanza y aprendizaje a distancia o presencial.',
    style: ['paragraph', 'italic'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '1. Detective sonoro',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Cada estudiante debe hacer un inventario de al menos cinco sonidos que comenzaron a formar parte de su vida cotidiana durante la cuarentena. Inventariar los sonidos que se producen dentro de la casa, los sonidos que llegan de los vecinos, de las ventanas, de las calles. Grabar los sonidos inventariados en audio o vídeo. Elegir tres sonidos y crear una forma de reproducirlos en su instrumento. No tiene que ser una reproducción literal, sino una que tenga sentido para la persona que la creó. Grabar los tres sonidos creados con el violonchelo. Enviar a un compañero los sonidos creados. Cada estudiante tiene la tarea de descubrir cuál fue el sonido original que inspiró a su compañero. Mientras el estudiante que recibió la grabación no descubre cuál es el sonido original, la persona que lo creó envía "pistas" hasta que el compañero lo identifique. Establecer de antemano el tiempo que se dará para descubrir el sonido del compañero antes de enviar una nueva pista, y así sucesivamente.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '2. ¿Qué sonido es este?',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Cada estudiante deberá enviar a un compañero la grabación original de uno de sus sonidos inventariados. Quien recibió y quien envió el sonido deben crear, individualmente, sus propias versiones con sus instrumentos para representar este sonido. A continuación, escuchar colectivamente los dos sonidos creados por los dos estudiantes. Observar y discutir las diferencias y similitudes. También se puede crear una representación colectiva para el sonido original, tras las consideraciones que surgirán de esta conversación.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '3. Teléfono descompuesto sonoro virtual',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Un estudiante (estudiante 1) debe grabar un breve fragmento de alguna creación suya en su instrumento. Puede ser una célula rítmica, melódica, sonoridades expandidas, etc. Luego lo envía a un compañero (estudiante 2). El compañero sólo puede escuchar el fragmento recibido tres veces. A continuación, graba su versión del fragmento y la envía a otro compañero (estudiante 3). Así se desarrolla la actividad hasta que todo el grupo haya participado. Al final, las grabaciones se escuchan colectivamente en secuencia (1, 2, 3, 4, ...). La clase debe discutir lo que ocurrió en el proceso, si hubo cambios, cómo se produjeron, si las grabaciones son similares, etc.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '4. Lego musical',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Un estudiante (estudiante 1) debe grabar un breve fragmento de alguna creación suya en su instrumento. Como en el juego anterior, puede ser una célula rítmica, melódica, sonoridades expandidas, etc. Lo envía a un compañero (estudiante 2). Quien haya recibido la grabación deberá escucharla tantas veces como quiera e intentar reproducir el mismo fragmento con su instrumento. Su versión no tiene que ser exactamente igual, pero debe ser similar a la grabación recibida. El estudiante 2 debe crear un fragmento más y añadirlo a la creación de su compañero. Grabar los dos fragmentos en secuencia (fragmento 1, fragmento 2) y enviarlos a otro compañero (estudiante 3). El estudiante que recibió la grabación debe hacer el mismo proceso, continuar la creación y enviar una grabación de los 3 fragmentos en secuencia (fragmento 1, fragmento 2, fragmento 3) a otro compañero. La actividad debe continuar sucesivamente hasta volver al primer estudiante (estudiante 1), quien debe reproducir toda la creación. Todos escuchan colectivamente la versión final y comentan lo que escucharon, compartiendo sus percepciones, ideas, etc.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '5. Historias desde la ventana',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Cada estudiante debe grabar los sonidos de su ventana o del patio trasero de su casa durante unos tres minutos en tres momentos del día: mañana, tarde y noche. Las grabaciones deben realizarse siempre en el mismo lugar. Cada estudiante debe escuchar las tres grabaciones y observar si hay diferencias o similitudes entre los sonidos grabados, como intensidades, timbres, colores, movimientos, etc. Cada estudiante debe crear una historia musical con su instrumento, con un principio, un medio y un final, que cuente algo sobre estos tres momentos sonoros diferentes o similares del día. A continuación, cada estudiante debe grabar su historia musical y enviarla a un compañero. El estudiante que recibe la grabación debe escuchar atentamente la historia musical de su compañero y crear un breve texto, escrito u oral, que cuente lo que imaginó con la historia musical recibida.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '6. Escribiendo la historia',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Este juego es una continuación del juego 5. El estudiante que recibió el relato grabado de su compañero debe construir, a su manera, una "partitura" o representación gráfica, en la que incluye su forma de registrar la historia sonora recibida.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '7. Espejito, espejito',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Cada estudiante debe elegir tres sonidos grabados con su instrumento y enviarlos a un compañero. Este compañero (estudiante 2) debe crear una partitura o representación gráfica para el sonido recibido en la grabación. A continuación, debe enviar la partitura creada a un tercer compañero (estudiante 3), quien debe, con su instrumento, interpretar la partitura a su manera. Posteriormente, todos escuchan el sonido grabado por el estudiante 1 y luego la versión del estudiante 3. Juntos observan y hablan de las similitudes y diferencias. También pueden crear colectivamente una nueva interpretación o una nueva partitura.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '8. Mapa musical',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'La clase debe crear colectivamente un mapa sonoro virtual. Este mapa, dependiendo de cada clase, puede ser un mapa del país, estado, provincia, ciudad, barrio o calle. Inicialmente, utilizar una foto, una imagen o un dibujo para crear un mapa, según la elección del grupo. Colocar este mapa en una plataforma digital, donde pueda ser visto por toda la clase. Cada persona debe grabar con su instrumento al menos tres pequeños vídeos o audios con sonidos que representen el lugar donde vive. Estos sonidos pueden ser sonidos de la casa o del entorno. El profesor recibe estos vídeos o audios, crea un enlace en algún medio social y adjunta el enlace al mapa, en el lugar donde vive esta persona. Luego, pone el mapa con los vídeos o audios enlazados a disposición de todos los miembros de la clase. Reservar uno o más momentos en los que la clase pueda ver los vídeos de forma colectiva, estableciendo los diálogos que pueden surgir de esta experiencia.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '9. Sonidos de la “saudade” (nostalgia)',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Cada persona del grupo investiga en su instrumento algunos sonidos que representan, para ellos, lugares, cosas, personas, situaciones, experiencias que echan de menos porque no están presentes, o no están siendo experimentados, debido a la distancia física. En una reunión colectiva, cada persona de la clase muestra el sonido elegido con su instrumento, o con una grabación previamente realizada. A continuación, cuentan a sus compañeros un poco sobre el sonido elegido y lo que representa para ellos.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '10. Nuestra música de la cuarentena',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Colectivamente, la clase debe crear una música que englobe todos los sonidos elegidos en la actividad 9. La clase debe decidir si va a contar una historia colectiva con estos sonidos o si la música no será descriptiva, cómo se organizarán los sonidos, si sonarán simultáneamente o en secuencia. Además de las elecciones musicales, hay que tener en cuenta la destreza y las posibilidades tecnológicas disponibles para cada grupo. Cada estudiante deberá grabar un breve vídeo con su instrumento, interpretando el sonido que haya elegido. Una o varias personas montan un vídeo o audio con la música creada según las directrices de la clase y luego lo presentan para que todos lo escuchen colectivamente. Este proceso puede durar tantas clases como sea necesario, ya que las combinaciones realizadas pueden ser evaluadas y, en consecuencia, modificadas hasta que la clase llegue a un consenso sobre la propuesta final. Después, la clase puede escribir colectivamente una partitura o representación gráfica de la música creada.',
    style: ['paragraph'],
  },
]
